import { render, staticRenderFns } from "./Mais.vue?vue&type=template&id=7c0215a3&scoped=true"
import script from "./Mais.vue?vue&type=script&lang=js"
export * from "./Mais.vue?vue&type=script&lang=js"
import style0 from "./Mais.vue?vue&type=style&index=0&id=7c0215a3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0215a3",
  null
  
)

export default component.exports